import React from 'react';
import PropTypes from 'prop-types';
import history from '../../core/history';
import withStyles from '../../core/isomorphic-style-loader/withStyles';
import s from './Logo.css';

const goHome = () => history.push('/');

const getImgName = props => (props.showGreyLogo ? 'solv-grey' : 'solv_dark');

const getImagePath = props => `/images/logo/${getImgName(props)}.svg`;

const Logo = props => (
  <div className={props.className} onClick={props.handleLogoOnClick} style={props.style}>
    <img src={getImagePath(props)} height={props.height} alt="Solv" className={s.logoImage} />
  </div>
);

Logo.propTypes = {
  className: PropTypes.string,
  height: PropTypes.number,
  handleLogoOnClick: PropTypes.func,
  style: PropTypes.object,
  showGreyLogo: PropTypes.bool,
};

Logo.defaultProps = {
  height: 16,
  handleLogoOnClick: goHome,
  style: {},
};

export default withStyles(s)(Logo);
